// @flow

import * as React from "react";

import { Error500Page } from "tabler-react";
import { history } from '../../../utils/helpers/history';


function Error500() {
  return <Error500Page onclick={history.push("/")} />;
}

export default Error500;